export const productExtras: {
	[key: string]: {
		description: string | undefined;
		type: string;
		options: Array<string> | undefined;
		default?: string | number;
		maxLength: number | undefined;
		maxValue: number | undefined;
		price: number;
		rules?: {
			[key: string]: string[];
		};
	};
} = {
	'Pre-printed Dark Chocolate ‘Happy Birthday’ Plaque': {
		description: undefined,
		type: 'checkbox',
		options: undefined,
		maxLength: undefined,
		maxValue: undefined,
		price: 1
	},
	'Printed Text': {
		description: undefined,
		type: 'text',
		options: undefined,
		maxLength: 30,
		maxValue: undefined,
		price: 8
	},
	'Extra cream cheese frosting': {
		description:
			'3 extra tubs of our delicious award winning cream cheese frosting.',
		type: 'checkbox',
		options: undefined,
		maxLength: undefined,
		maxValue: undefined,
		price: 5
	},
	'Handmade Buttercream Roses': {
		description:
			'Approximately 5 handcrafted buttercream roses in your choice of pink, red, lavender, or multicoloured. You can make any notes under “Special Instructions” below.',
		type: 'select',
		options: [
			'Pink',
			'Red',
			'Lavender',
			'Multicoloured',
			'White (Vanilla)',
			'Chocolate'
		],
		maxLength: undefined,
		maxValue: undefined,
		price: 8
	},
	'Coloured Vanilla Frosting': {
		description: undefined,
		type: 'select',
		options: [
			'Light Pink',
			'Bright Pink',
			'Light Blue',
			'Bright Blue',
			'Purple',
			'Yellow',
			'Orange',
			'Green'
		],
		maxLength: undefined,
		maxValue: undefined,
		price: 5,
		rules: { baseFlavours: ['Vanilla'] }
	},
	'Coloured Vanilla Frosting Just Pink': {
		description: undefined,
		type: 'select',
		options: ['Pink'],
		maxLength: undefined,
		maxValue: undefined,
		price: 5,
		rules: { baseFlavours: ['Vanilla'] }
	},
	Branding: {
		description: undefined,
		type: 'checkbox',
		options: undefined,
		maxLength: undefined,
		maxValue: undefined,
		price: 3
	},
	'Custom Branding': {
		description: undefined,
		type: 'checkbox',
		options: undefined,
		maxLength: undefined,
		maxValue: undefined,
		price: 8
	},
	Sprinkles: {
		description: undefined,
		type: 'select',
		options: ['Rainbow', 'Chocolate'],
		default: 'Chocolate',
		maxLength: undefined,
		maxValue: undefined,
		price: 0
	},
	Candles: {
		description: undefined,
		type: 'number',
		options: undefined,
		maxLength: undefined,
		maxValue: 20,
		price: 5
	}
};
